/*
 * Application Insights JavaScript SDK - Core, 3.0.1
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */


export var ChannelControllerPriority = 500;
//# sourceMappingURL=Constants.js.map